import { Box } from '@mui/material';
import { WorkflowCanvas } from './workflow-canvas';
import { useWorkflowGraph } from './graph/hooks/use-workflow-graph';
import { useSidebarControl } from './hooks/use-sidear-control';
import { WorkflowSidebar } from '../workflow-sidebar/workflow-sidebar';

export const WorkflowEditor = ({
  graphControl,
}: {
  graphControl: ReturnType<typeof useWorkflowGraph>;
}) => {
  const sidebarControl = useSidebarControl(graphControl);

  return (
    <Box height="100%" width="100%" display="flex" flexDirection="column">
      <WorkflowCanvas graphControl={graphControl} onNodeDoubleClick={sidebarControl.openEdit} />
      <WorkflowSidebar controller={sidebarControl} />
    </Box>
  );
};
